export const CONTACT_ENDPOINT = `${(process.env.REACT_APP_SUPABASE_URL || "https://ullvjzbhgoqsfjiopvem.supabase.co").replace(/\/$/, "")}/functions/v1/contact-inquiries`;
export const CONTACT_LIMITS = { name: 120, email: 254, message: 10000 };
const UUID = /^[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12}$/i;

export function validateInquiry(form) {
  const fields = {};
  for (const [field, limit] of Object.entries(CONTACT_LIMITS)) {
    fields[field] = String(form[field] || "").trim();
    if (!fields[field]) return { error: { field, message: field === "message" ? "Tell us a little about what you need." : `Enter your ${field === "name" ? "name" : "email address"}.` } };
    if (fields[field].length > limit) return { error: { field, message: `Keep this field to ${limit.toLocaleString()} characters or fewer.` } };
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) return { error: { field: "email", message: "Enter a valid email address so we can reply." } };
  return { fields };
}

export function newInquiryId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  if (!globalThis.crypto?.getRandomValues) throw new Error("Your browser could not prepare the message. Please use the copy option below.");
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = [...bytes].map(value => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export async function sendInquiry(payload, { timeoutMs = 30000 } = {}) {
  const controller = new AbortController();
  let timer;
  try {
    const { response, result } = await Promise.race([
      fetch(CONTACT_ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), signal: controller.signal })
        .then(async response => ({ response, result: await response.json().catch(() => null) })),
      new Promise((_, reject) => { timer = setTimeout(() => { controller.abort(); reject(new Error("timeout")); }, timeoutMs); }),
    ]);
    if (!response.ok) {
      const error = new Error(typeof result?.error?.message === "string" && result.error.message.length <= 400 ? result.error.message : "We could not send your message. Please try again.");
      if (Object.hasOwn(CONTACT_LIMITS, result?.error?.field)) error.field = result.error.field;
      if (UUID.test(result?.inquiry_id || "")) error.reference = result.inquiry_id;
      if (typeof result?.retryable === "boolean") error.retryable = result.retryable;
      throw error;
    }
    if (result?.ok !== true || !UUID.test(result.inquiry_id || "")) throw new Error("We could not confirm receipt. Please retry with the same message.");
    return result;
  } catch (error) {
    if (controller.signal.aborted || error?.name === "AbortError") throw new Error("We could not confirm receipt yet. Your message is still here; please retry with the same answers.");
    if (error instanceof TypeError) throw new Error("We could not connect. Check your connection and try again. Your message is still here.");
    throw error;
  } finally { clearTimeout(timer); }
}
